export const environment = {
  AppID: 20,
  host: 'https://tst.loctitepulse.henkelgroup.cloud/appbackend/',
  installation_agent_url: 'https://app-test.loctite-pulse.com/ia',
  rm_parameter_key: 'cc_rm_param',
  debugMode: false,
  taskLimit: 4000,
  locale: 'en',
  href: '/em',
  debugAuth: false,
  appLogo: './assets/images/LoctitePulseLogo.svg',
  hasBusinessCentral: false,
  credentialLogin: true,
  portalLogin: false,
  msalLogin: true,
  msalPopup: false,
  msalClientID: '5dc58c9b-6c4b-426f-b651-10ab19aa9c71', // henkel
  msalIssuerService: 'https://login.microsoftonline.com/',
  msalIssuerServiceTenant: 'organizations',
  debugCredentials: null,
  authorization_uri: '',
  redirect_uri: 'https://app-test.loctite-pulse.com/em/login',
  logout_uri: 'https://www.ccsmartequipment.com/',
  client_id: 'cc_loctite_pulse',
  fakeTelemetry: false,
  environmentInstanceName: 'TEST',
  disableTabletView: false,
  disableSignup: false,
  disableSelectedSteamRateCurrency: false,
  nanoPreciseDashboardURL: 'https://staging.nanoprecisedataservices.com/nanop_dashboard/',
  appName: 'em',
  enableCaptcha: true,
  captchaSitekey: 'FCMP709RULE713A9',
  favicon: 'assets/feedback-test.ico',
  prefix_installation_agent_uri: 'https://app-test.loctite-pulse.com/ia',
  prefix_equipment_monitor_uri: 'https://app-test.loctite-pulse.com/em',
};
